import clientConfig from '../config/clients';
import { hasCompletePricingSnapshot } from '@msales/shared/utils/orderPricingSnapshot';
import { copyPricingSnapshot } from '@msales/shared/utils/orderPricingSnapshot';

export const requiresPricingReview = (operation) =>
  clientConfig.productPricing.usePriceInquiry &&
  operation?.type === 'INSERT_ORDER' &&
  (operation.needsPricingReview ||
    !operation.variables?.input?.items?.length ||
    operation.variables.input.items.some((item) =>
      !hasCompletePricingSnapshot(item) ||
      [item.discount1, item.discount2, item.discount3].some((rate) =>
        rate == null || String(rate).trim() === '' || !Number.isFinite(Number(rate)))));

export const applyPriceInquiryToItems = (items, quotes) => {
  const byProductId = new Map(quotes.map((quote) => [String(quote.productId), quote]));
  return items.reduce((priced, item) => {
    const quote = byProductId.get(String(item.id));
    const rates = quote ? [quote.rabat1_PCT, quote.rabat2_PCT, quote.rabat3_PCT] : [];
    const usable = quote && hasCompletePricingSnapshot(quote) &&
      rates.every((rate) =>
        rate != null && String(rate).trim() !== '' && Number.isFinite(Number(rate)));
    if (usable) {
      priced.push({
        ...item,
        ...copyPricingSnapshot(quote),
        discount1: Number(rates[0]),
        discount2: Number(rates[1]),
        discount3: Number(rates[2]),
      });
    }
    return priced;
  }, []);
};

export const buildConfirmedPriceReview = (operation, reviewed) => {
  const items = reviewed.filter((item) => Number(item.quantity) > 0);
  if (!items.length) throw new Error('Prazna narudžba se ne može poslati.');
  const cartItems = items.map((item) => ({
    ...(operation.cartItems || []).find((original) => String(original.id) === String(item.id)),
    ...item,
  }));
  const totalField = operation.usesGrossPrices === false
    ? 'krajnjaCenaBezPDV' : 'krajnjaCenaSaPDV';
  const total = items.reduce((sum, item) =>
    sum + Number(item[totalField]) * Number(item.quantity), 0);
  return {
    items,
    cartItems,
    total,
    variables: {
      ...operation.variables,
      input: { ...operation.variables.input, items, total },
    },
  };
};
